/**
 * LoadingState Component
 * Reusable loading state for data sections
 */

import React from 'react';
import { LoadingStateProps } from './types';
import '../Planets/Planets.css';

/**
 * LoadingState component - Displays loading spinner and message
 */
export const LoadingState: React.FC<LoadingStateProps> = ({
  message,
  className = ''
}) => {
  return (
    <div className={`planets-container ${className}`}>
      <div className="planets-loading">
        <div className="loading-spinner"></div>
        <span className="loading-text">{message}</span>
      </div>
    </div>
  );
};

export default LoadingState;